module.exports = __webpack_public_path__ + "images/file_icons_v2/flv-0cf56fda32993842663ca1f73a69a041.svg";